export default {"src":"/_next/static/media/government.8ba984ad.svg","height":192,"width":215};